import React, {useEffect, useState} from "react";
import Loading from "./loading";
import {observer} from "mobx-react";
import Store from "../store";
import RenewStepOne from "./renew-step-one";
import RenewStepTwo from "./renew-step-two";
import ResponsiveAppBar from "./responsive-app-bar";
import Footer from "./home/Footer";
import {Container} from "@mui/material";
import Spacer from "./Spacer";
import {determineLocation} from "../assets/determineLocation";
import {RenewalStepFlowDisplay} from "./renewal-step-flow-display";
import RenewalStore from "../stores/renewal-store";
import {postFetch} from "../api/client";
import ErrorMessage from './error';
import {prepareCompanyReview} from '../assets/company-review';
import {PageErrorBoundary} from './page-error-boundary';

const CompanyRenew = observer(({documentNumber}) => {
    const [loading, setLoading] = useState(true);
    const [companyInfo, setCompanyInfo] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        let active = true;
        RenewalStore.invalidateSignature();
        Store.setRenewStep(1);
        setLoading(true);
        setErrorMessage('');
        fetch(`${determineLocation()}/company/${documentNumber}`).then(async response => {
            const body = await response.json();
            if (!response.ok || !body.message?.id) throw new Error('Company details could not be loaded. Please refresh and try again.');
            if (!active) return;
            // Missing addresses, agent or officers become empty, editable values. The original is prepared the same
            // way so the signed changes list only what the visitor edits.
            const company = prepareCompanyReview(body.message);
            setCompanyInfo(company);
            RenewalStore.setCompanyInfo(company);
            RenewalStore.setUpdatedCompanyInfo(JSON.parse(JSON.stringify(company)));
            setLoading(false);
            postFetch({endpoint: `billing/${documentNumber}`, authenticate: false}).catch(() => {});
        }).catch(error => {
            if (!active) return;
            setErrorMessage(error instanceof Error ? error.message : 'Company details could not be loaded.');
            setLoading(false);
        });
        return () => { active = false; };
    }, [documentNumber]);

    if (loading) {
        return <Loading/>
    }
    if (errorMessage) return <ErrorMessage message={errorMessage}/>;

    return (<>
        <ResponsiveAppBar showLogin={false}/>
        <Container maxWidth={"md"}>
            <Spacer height={50}/>
            <RenewalStepFlowDisplay/>
            <Spacer height={20}/>
            <PageErrorBoundary>{analyzeRenewalStep(companyInfo)}</PageErrorBoundary>
        </Container>
        <Spacer height={250}/>
        <Footer/>

    </>);

})

function analyzeRenewalStep(companyInfo) {
    switch (Store.getRenewStep) {
        case 1:
            return (
                <RenewStepOne companyInfo={companyInfo}/>
            )
        case 2:
            return (
                <RenewStepTwo companyInfo={companyInfo}/>
            )
        default:
            return (
                <div>Error Step</div>
            )
    }
}

export default CompanyRenew
